import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotSection from './components/HotSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import GenresSection from './components/GenresSection';
import ReadingSection from './components/ReadingSection';
import ExperienceSection from './components/ExperienceSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

function ScrollTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition hover:bg-primary-600"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <HotSection />
        <UpdatesSection />
        <RankingSection />
        <GenresSection />
        <ReadingSection />
        <ExperienceSection />
        <FaqSection />
      </main>
      <Footer />
      <ScrollTopButton />
    </div>
  );
}